export default "__VITE_ASSET__mpPUkDw5__"